import React from 'react'
import "./contact.css";
import Button from '@mui/material/Button';
function contact() {
  return (
  <section className="paddings contactSection">
    <div className="headerContent">
        <h1 className='xl:text-4xl font-bold capitalize'>Do You Have Questions ?</h1>
        <p>We'll help you to grow your career and growth.</p>
    </div>
    <Button variant='contained'><a href="mailto:hichamcodes71@gmail.com">contact us today</a></Button>
  </section>
  )
}

export default contact
